<template>
  <div>
    <b-alert show>{{ getInnerCardDetail }}</b-alert>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  props: ["projectDetail"],
  name: "ViewProjectDetail",
  data() {
    return {
      project_id: "",
    };
  },
  computed: {
    ...mapGetters(["getInnerCardDetail", "getProjectPlatforms"]),
  },
  mounted() {
    this.loadContent();
  },

  methods: {
    ...mapActions([
      "FetchInnerCard",
      "CreateProjectPlatform",
      "DeleteProjectPlatform",
      "showLoadingProcess",
      "closeLoading",
    ]),

    async loadContent() {
      await this.showLoadingProcess();
      try {
        const id = this.projectDetail.id;
        await this.FetchInnerCard(id); // TODO: title case?
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
  },
};
</script>
